import React from 'react'
import { useGetIdentity } from '@pankod/refine-core'
import {
  AntdLayout,
  Avatar,
  Badge,
  Button,
  Divider,
  Tooltip,
  Typography,
} from '@pankod/refine-antd'

import {
  getTheme,
  LOCAL_STORAGE_THEME_VAR,
  THEME,
  toggleTheme,
} from 'src/helpers/theme'
import { BASE_PATH } from '../../../constant'

const { Text } = Typography

export const Header: React.FC = () => {
  const { data } = useGetIdentity()

  const user = data?.user
  const shouldRenderHeader = user && (user.name || user.picture)
  const isDarkTheme = getTheme() === THEME.DARK

  return shouldRenderHeader ? (
    <AntdLayout.Header
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        padding: '0px 24px',
        height: '64px',
        lineHeight: 'unset',
        zIndex: 99,
        position: 'sticky',
        top: 0,
      }}
      className="layout-header"
    >
      <div className="flex gap-2 items-center">
        <Tooltip
          placement="bottom"
          color={isDarkTheme ? '#FFF' : undefined}
          overlayInnerStyle={{
            color: isDarkTheme ? 'rgba(0, 0, 0, 0.85)' : '#FFF',
          }}
          title={
            <>
              Switch to <strong>{isDarkTheme ? 'Light' : 'Dark'} Theme</strong>
            </>
          }
        >
          <Badge
            offset={[-5, 5]}
            color="red"
            dot={!localStorage.getItem(LOCAL_STORAGE_THEME_VAR)}
          >
            <Button
              shape="circle"
              className="!m-0 !p-0"
              type="text"
              onClick={() => toggleTheme()}
            >
              {isDarkTheme ? (
                <img src={`${BASE_PATH}/img/theme/sun.svg`} alt="light" />
              ) : (
                <img src={`${BASE_PATH}/img/theme/moon.svg`} alt="dark" />
              )}
            </Button>
          </Badge>
        </Tooltip>
        <Divider type="vertical" />
        <div className="app-header__user-info">
          {user.name && (
            <Text ellipsis strong>
              {user.name}
            </Text>
          )}
          <br />
          {user.email && (
            <Text ellipsis type="secondary">
              {user.email}
            </Text>
          )}
        </div>
        {user.picture && (
          <Avatar size="large" src={user?.picture} alt={user?.name} />
        )}
      </div>
    </AntdLayout.Header>
  ) : null
}
